import { Button } from '@trukt/ui/Button';
import { CircleHelp } from '@trukt/ui/icons';

const LINK = 'https://trukt.com/help';

export const HelpCenterButton = () => {
  const handleNavigate = () => {
    window.open(LINK, 'blank');
  };

  return (
    <Button
      onClick={handleNavigate}
      startIcon={
        <CircleHelp
          role="img"
          aria-label="Help Center"
          size={16}
          className="stroke-secondary-300 group-hover:stroke-bg-primary"
        />
      }
      className="group !bg-bg-primary font-700 !text-secondary-300 hover:!bg-bg-secondary hover:!text-bg-primary"
      boxShadowVariant="primary"
    >
      Help Center
    </Button>
  );
};
